module.exports = __webpack_public_path__ + "static/media/grundriss_loggia.2cd0f9e5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/projekte/grundriss_loggia.gif
// module id = 358
// module chunks = 0